import {defineAsyncComponent} from "vue";
import {toast} from "vue3-toastify";
import {i18n} from "@/lang";

const RELOAD_KEY = "chunkReloadAt";
const RELOAD_COOLDOWN_MS = 10000;
const pendingLoaders = [];

export function isChunkLoadError(error) {
    const message = String(error?.message || "");
    return error?.name === "ChunkLoadError"
        || /Loading (CSS )?chunk [\w-]+ failed/i.test(message);
}

function readLastReload() {
    try {
        return Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
    } catch (e) {
        return 0;
    }
}

function writeLastReload(at) {
    try {
        sessionStorage.setItem(RELOAD_KEY, String(at));
    } catch (e) {
        return;
    }
}

export function reloadForNewVersion(path) {
    const now = Date.now();
    if (now - readLastReload() < RELOAD_COOLDOWN_MS) return false;
    writeLastReload(now);
    if (path) window.location.assign(path);
    else window.location.reload();
    return true;
}

export function notifyNewVersion() {
    toast.error(i18n.global.t("generic.newVersionReload"), {autoClose: false, toastId: "new-version"});
}

export function lazyRoute(loader) {
    pendingLoaders.push(loader);
    return loader;
}

export function lazyComponent(loader) {
    pendingLoaders.push(loader);
    return defineAsyncComponent({
        loader,
        onError(error, retry, fail) {
            if (isChunkLoadError(error)) {
                if (reloadForNewVersion()) return;
                notifyNewVersion();
            }
            fail(error);
        }
    });
}

function whenIdle(callback) {
    if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(callback, {timeout: 2000});
    else setTimeout(callback, 200);
}

export function prefetchWhenIdle() {
    const next = () => {
        const loader = pendingLoaders.shift();
        if (!loader) return;
        loader().catch(() => null).finally(() => whenIdle(next));
    };
    whenIdle(next);
}
